import React from "react";
import { motion } from "framer-motion";
import { FaMapMarkerAlt } from "react-icons/fa";

const fadeIn = {
  hidden: { opacity: 0, y: 40 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.7 } }
};

const LocationSection = () => (
  <motion.section
    className="container mx-auto py-12 px-4 flex flex-col items-center"
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true, amount: 0.2 }}
    variants={fadeIn}
  >
    <h2 className="text-2xl sm:text-3xl font-bold mb-4 text-center flex items-center gap-3">
      <FaMapMarkerAlt className="text-red-500 text-2xl" />
      ¿Dónde estamos?
    </h2>
    <p className="text-gray-600 text-center mb-6 max-w-xl">
      Ven a visitarnos, ¡te esperamos en nuestra tienda física!
    </p>
    <div className="w-full max-w-3xl rounded-2xl overflow-hidden shadow-xl border-4 border-blue-200">
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3952.5555468902276!2d-72.4699898!3d7.836772600000002!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8e6647dee4878345%3A0xc4721b9e8c8c06ea!2sACUARIO%20ATLANTIS%20FISH!5e0!3m2!1ses-419!2sco!4v1753120675879!5m2!1ses-419!2sco"
        width="100%"
        height="350"
        style={{ border: 0 }}
        allowFullScreen=""
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        title="Ubicación Acuario Atlantis Fish"
      ></iframe>
    </div>
    {/* Si quieres un botón "Cómo llegar" directo a Google Maps */}
<a
  href="https://maps.app.goo.gl/YycCbCVvbfztV5x59"
  target="_blank"
  rel="noopener noreferrer"
  className="mt-6 bg-blue-600 text-white font-bold px-6 py-3 rounded-full shadow hover:bg-blue-700 transition"
>
  Cómo llegar
</a>
  </motion.section>
);

export default LocationSection;
